import { sendTransactionalLog } from './sendTransactionalLog'
import type {
  TransactionalLogActor,
  TransactionalLogEventPayload,
} from './types'
import { getTransactionalLogActor } from './logContext'

export interface SendLogOptions {
  actor?: TransactionalLogActor | null
}

export function sendLog(
  eventName: string,
  payload: TransactionalLogEventPayload,
  options: SendLogOptions = {}
): void {
  const actor = options.actor ?? getTransactionalLogActor()
  if (!actor) {
    if (process.env.NODE_ENV === 'development') {
      console.debug(
        '[transactionalLog] sendLog sem actor (evento omitido):',
        eventName
      )
    }
    return
  }

  sendTransactionalLog({
    eventName,
    actor,
    trace: payload.trace,
    target: payload.target,
    result: payload.result,
    meta: payload.meta,
    meta_raw: payload.meta_raw,
    meta_dim: payload.meta_dim,
    action: payload.action,
  })
}
